var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBox',{attrs:{"maxW":"100vw","overflow":"hidden","rounded":"sm","border-width":"1px","p":5}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }